import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/auth/AuthContext";
import { CookieConsentRoot } from "@/components/CookieConsentRoot";
import { RootErrorBoundary } from "@/components/RootErrorBoundary";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <HelmetProvider>
        <CookieConsentRoot>
          <AuthProvider>
            <App />
          </AuthProvider>
        </CookieConsentRoot>
      </HelmetProvider>
    </RootErrorBoundary>
  </React.StrictMode>,
);
